module.exports = __webpack_public_path__ + "img/ctkjbanner2.f19dee12.png";